import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useForm } from "react-hook-form";
import { useCreateAgendaItemResource } from "../../../http";
import { IResource } from "../../../models";
import { lexorank } from "../../../utilities";
import { v4 as newGuid } from "uuid";
import { CreateEditAgendaItemResourceForm, ICreateEditAgendaItemResourceFormState } from ".";

interface IProps {
  agendaStepGuid: string;
  resources: IResource[];
  visible: boolean;
  onAdded: () => void;
  onCancelled: () => void;
}

const CreateAgendaItemResourceModal = (props: IProps) => {
  const { mutate, isLoading: isCreating } = useCreateAgendaItemResource();
  const { formState, control, handleSubmit, reset } = useForm<ICreateEditAgendaItemResourceFormState>({
    defaultValues: {
      title: "",
      url: "",
      isEmbedded: false,
      sortOrder: "",
    },
  });

  async function handleCreateClicked() {
    handleSubmit((data) => {
      mutate(
        {
          agendaItemGuid: props.agendaStepGuid,
          resourceGuid: newGuid(),
          title: data.title,
          url: data.url,
          isEmbedded: data.isEmbedded,
          sortOrder: lexorank.getNextRank(props.resources),
        },
        {
          onSuccess: () => {
            reset(undefined, { keepDefaultValues: true });
            props.onAdded();
          },
        }
      );
    })();
  }

  function handleClose(_: object, reason: string) {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }

    handleCancelClicked();
  }

  function handleCancelClicked() {
    reset(undefined, { keepDefaultValues: true });
    props.onCancelled();
  }

  return (
    <Dialog open={props.visible} onClose={handleClose}>
      <DialogTitle>Create Resource</DialogTitle>
      <DialogContent>
        <CreateEditAgendaItemResourceForm formState={formState} control={control} />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" disabled={isCreating} onClick={handleCancelClicked}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={isCreating}
          endIcon={isCreating ? <CircularProgress size={20} sx={{ color: "grey.400" }} /> : null}
          onClick={handleCreateClicked}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { CreateAgendaItemResourceModal };
